import { AbstractCommand } from './AbstractCommand';
import { CommandResponse } from '../types';
import { getSequenceId } from '../utils/sequenceIdManager';

export class UnloadFilamentCommand extends AbstractCommand {
  private static readonly UNLOAD_TRAY_ID = 255;
  public readonly category = 'print';
  public readonly command = 'ams_change_filament' as const;

  constructor({
    oldTemp = 210,
    newTemp = 210
  }: {
    oldTemp?: number;
    newTemp?: number;
  } = {}) {
    super({
      curr_temp: oldTemp,
      tar_temp: newTemp,
      target: UnloadFilamentCommand.UNLOAD_TRAY_ID,
    });
  }

  ownsResponse(response: CommandResponse, sequence_id?: string): boolean {
    if (!('print' in response)) {
      return false;
    }

    const printResponse = response as { print: { sequence_id?: string | undefined } };
    const responseId = printResponse.print?.sequence_id;
    const extraId = this.extra?.sequence_id;

    if (!responseId) {
      return false;
    }

    if (sequence_id && responseId === sequence_id) {
      return true;
    }

    if (extraId && responseId === extraId) {
      return true;
    }

    return false;
  }
}